import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import {
  useProcessDefinitionDraftDelete,
  useProcessDefinitionsDrafts,
} from "../../../../hooks/drafts";
import { language } from "../../../../language";
import Table, { GridActionsCellItem } from "../../../generic-table";
import Modal from "../../../modal-closebtn/modalForTable";

const INITIAL_LIST_STATE = {
  page: 0,
  pageSize: 10,
  sortBy: "processKey",
  sortOrder: "asc",
  processName: "",
  processKey: "",
};

function SelectDraftModal(props) {
  const { onSelectDraft, handleCancel, openDialog } = props;

  const [pagination, setPagination] = useState(INITIAL_LIST_STATE);

  const { data: draftList } = useProcessDefinitionsDrafts({
    params: pagination,
  });

  const { mutate: deleteProcessDefinitionDraft } =
    useProcessDefinitionDraftDelete({
      params: pagination,
    });

  const dataTable = {
    headers: [
      {
        flex: 1,
        headerName: language.id,
        field: "processKey",
        customFilterAndSearch: (_term, rowData) => rowData,
      },
      { flex: 1, headerName: language.name, field: "processName" },
      { flex: 1, headerName: language.category, field: "category" },
      {
        flex: 1,
        headerName: language.creationDate,
        field: "createdAt",
        type: "dateTime",
        valueGetter: (value) => value && new Date(value),
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Ações",
        width: 100,
        cellClassName: "actions",
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              icon={<EditIcon />}
              label={language.edit}
              className="textPrimary"
              onClick={() => {
                onSelectDraft(id);
              }}
              color="inherit"
            />,
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label={language.delete}
              onClick={async () => {
                await deleteProcessDefinitionDraft(id);
              }}
              color="inherit"
            />,
          ];
        },
      },
    ],
    data: draftList && draftList.content,
  };

  const dataPagination = {
    callData: setPagination,
    totalElements: draftList?.totalElements,
    model: {
      ...pagination,
      count: draftList?.size,
      sortHeader: INITIAL_LIST_STATE.sortBy,
    },
  };

  return (
    <Modal
      open={openDialog}
      handleClose={handleCancel}
      btnActionTitle={language.DraftSelection}
      size="xl"
      contentStyle={{ padding: "16px" }}
    >
      <Typography variant="h6">{language.Drafts}</Typography>
      <Table
        tableData={dataTable}
        pagination={dataPagination}
        paginationMode="server"
        forcedCloseOnClickMenu={true}
      />
    </Modal>
  );
}

export default SelectDraftModal;
